/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_Invite_Email_Not_SentInputs */

const cs_settings_users_invite_email_not_sent = /** @type {(inputs: Settings_Users_Invite_Email_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail s pozvánkou se neodeslal. Odkaz zkopírujte a pošlete sami.`)
};

const en_settings_users_invite_email_not_sent = /** @type {(inputs: Settings_Users_Invite_Email_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite email was not sent. Copy the link and send it yourself.`)
};

/**
* | output |
* | --- |
* | "Invite email was not sent. Copy the link and send it yourself." |
*
* @param {Settings_Users_Invite_Email_Not_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_invite_email_not_sent = /** @type {((inputs?: Settings_Users_Invite_Email_Not_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_Invite_Email_Not_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_invite_email_not_sent(inputs)
	return cs_settings_users_invite_email_not_sent(inputs)
});